import { useEffect, useState } from 'react'

export type Route = 'home' | 'tours'

export const TOURS_HASH = '#/tours'

function getRoute(): Route {
  return window.location.hash.startsWith(TOURS_HASH) ? 'tours' : 'home'
}

export function useHashRoute(): Route {
  const [route, setRoute] = useState<Route>(getRoute)

  useEffect(() => {
    const onHashChange = () => {
      const next = getRoute()
      setRoute((prev) => {
        if (prev !== next) {
          // Wait for the new page to render, then scroll
          requestAnimationFrame(() => {
            const hash = window.location.hash
            const target =
              next === 'home' && hash.length > 1 && !hash.startsWith('#/')
                ? document.getElementById(hash.slice(1))
                : null
            if (target) target.scrollIntoView()
            else window.scrollTo(0, 0)
          })
        }
        return next
      })
    }
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  return route
}
